import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_advisor')({
  component: AdvisorLayoutRoute,
});

function AdvisorLayoutRoute() {
  return <Outlet />;
}
